import { Link } from 'react-router-dom';

// The customer portal's landing page (Jeremy, 2026-09-09) -- the first thing any customer contact
// sees after signing in. Its one job is carrying the confidentiality notice; the actual work
// (schedule, calendar, registers) lives one click away via the nav or the button below.
export default function CustomerHome() {
  return (
    <div>
      <div className="page-header">
        <div className="page-eyebrow">Customer Portal</div>
        <div className="page-title">Welcome to Pulse</div>
        <div className="page-subtitle">Aumentum Technologies · Professional Services</div>
      </div>

      <div className="card" style={{ maxWidth: 720 }}>
        <div className="card-title">Confidentiality notice</div>
        <p style={{ fontSize: 13.5, lineHeight: 1.7, color: 'var(--text-mid)' }}>
          Aumentum Technologies considers materials and information presented on this forum as
          Confidential &amp; Proprietary. By accessing this site, you as the individual and your
          organization acknowledge that the materials and information presented is and shall remain
          the exclusive property of Aumentum Technologies. You agree not to disclose or otherwise
          make available the materials to any person outside your organization without the prior
          written consent of Aumentum Technologies.
        </p>
        <Link to="/schedule" className="btn btn-primary" style={{ marginTop: 8 }}>
          Continue to your project
        </Link>
      </div>
    </div>
  );
}
